/* eslint-disable @angular-eslint/directive-selector */

import { Directive, inject } from '@angular/core';
import { ButtonComponent } from '../components/basic/button/button.component';
import { ButtonType } from '../models/button-type.model';

@Directive({ selector: 'app-button[primary]' })
export class ButtonPrimaryDirective {
  private button = inject(ButtonComponent);

  constructor() {
    this.button.buttonStyle.set(ButtonType.Primary);
  }
}
